"use client";

import { useGetWalletBalance } from "@/hooks";
import { cn, formatNumber } from "@/lib";
import { useSession } from "next-auth/react";
import { BdWadOfMoney } from "solar-icon-react/bd";

const WalletBalanceSummary = ({ className }: { className?: string }) => {
  const { data: session, status } = useSession();
  const { data, isLoading } = useGetWalletBalance(session?.user.token);
  const balance = Number(data?.data?.balance || 0);

  if (status !== "authenticated") {
    return null;
  }

  return (
    <div className={cn("mb-4 border-b border-b-gray-300 pb-3", className)}>
      <div className="min-w-0 text-right">
        <div className="flex items-center gap-2">
          <BdWadOfMoney className="text-primary-main!" size={20} />
          <p className="text-custom-gray-600 text-xs leading-5">
            اعتبار کیف پول شما
          </p>
        </div>
        <p
          className={cn(
            "mt-1 truncate pr-7 text-base font-bold",
            balance < 0 ? "text-error-main" : "text-primary-main",
          )}
          dir="rtl"
        >
          {isLoading ? "..." : `${formatNumber(balance)} تومان`}
        </p>
      </div>
    </div>
  );
};

export default WalletBalanceSummary;
